import { firstExt, lastExt } from "./exts"

export default class Industry {
  constructor({ Class, extensions } = {}) {
    this.Class = Class
    this.extensions = new Map(extensions)
  }

  bindTo(target) {
    let self = this

    let modifiers = [
      "clear", "delete", "set"
    ]
    let accessors = [
      "entries", "forEach", "get", "has", "keys", "values"
    ]

    target.base = this.base.bind(this)

    modifiers.forEach(fn => {
      target[fn] = (...args) => {
        let industry = new Industry(self)
        industry.extensions[fn](...args)
        return industry.make()
      }
    })

    accessors.forEach(fn => {
      target[fn] = (...args) => {
        return self.extensions[fn](...args)
      }
    })

    return target
  }

  boundBase() {
    return this.bindTo(this.base.bind(this))
  }

  static boundBase(...args) {
    let industry = new Industry(...args)
    return industry.boundBase()
  }

  base(Class) {
    this.Class = Class
    return this.make()
  }

  static base(Class) {
    let industry = new Industry()
    return industry.base(Class)
  }

  callback({ args, Class, instance, time, type }) {
    let capitalized = this.capitalize(type)
    let once = Class.industry().flags[time]

    if (once[type] == false) {
      let flags = {}
      flags[time] = {}
      flags[time][type] = true

      Class.industry({ flags })
      this.callFnOn({
        args,
        fn: `${time}${capitalized}Once`,
        Class,
        instance
      })
    }
    
    this.callFnOn({
      args,
      fn: `${time}${capitalized}`,
      Class,
      instance
    })
  }

  callFnOn({ args, fn, Class, instance }) {
    let value

    if (Class && Class[fn]) {
      value = Class[fn](...args)
    }

    if (instance && instance[fn]) {
      value = instance[fn](...args)
    }

    return value
  }

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  make() {
    if (this.Class) {
      let extensions = this.extensionValues()
      extensions.unshift(firstExt)
      extensions.push(lastExt)

      let Class = extensions.reduce(
        (previous, current) => current(previous),
        this.Class
      )
      
      return this.bindTo((...args) => {
        this.callback({ args, Class, time: "before", type: "factory" })
        let instance = this.callFnOn({ args, fn: "factory", Class })
        
        if ([ "function", "object" ].indexOf(typeof instance) > -1) {
          instance.Class = Class

          this.callback({ args, Class, instance, time: "after", type: "factory" })

          if (!instance.industry().flags.init) {
            this.callback({ args, Class, instance, time: "before", type: "init" })
            instance.industry({ flags: { init: true } })
            this.callFnOn({ args, fn: "init", Class, instance })
            this.callback({ args, Class, instance, time: "after", type: "init" })
          }

        } else {
          this.callback({ args, Class, instance, time: "after", type: "factory" })
        }
        
        return instance
      })
    } else {
      return Industry.boundBase(this)
    }
  }

  extensionValues() {
    let values = []
    this.extensions.forEach(value => values.push(value))
    return values
  }
}
